import type { UseModule } from '~/types'
import { createHead } from '@vueuse/head'

// vueuse/head https://github.com/vueuse/head
export const install: UseModule = ({ instance }) => {
  const head = createHead()
  instance.use(head)
}
